export const qk = {
  products: {
    all: ["products"],
    list: (category, filters, sort) => [
      "products",
      "list",
      { category, filters, sort },
    ],
    preview: (category) => ["products", "preview", category],
    detail: (id) => ["products", "detail", id],
    related: (material, excludeId) => [
      "products",
      "related",
      { material, excludeId },
    ],
    media: (id) => ["products", "media", id],
    search: (q) => ["products", "search", q],
  },
  filters: (category) => ["filters", category],
  hero: ["hero"],
};
